import { css } from "@emotion/react";

export const styButton = css`
  background-color: #a99d87;
  color: #fff;
  border: none;
  padding: 16px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  width: 240px;
  transition: background-color 0.3s ease;
`;
